import { Subscription } from '../core/Subscription'
import { Order } from '../core/Order'

export class User {
	constructor (attributes) {
		var user = attributes

		user.subscription = user.subscription ? new Subscription(user.subscription) : null
		user.order = user.order ? new Order(user.order) : null
		user.recurring = typeof user.recurring === 'string' ? JSON.parse(user.recurring) : user.recurring

		for (let key in user) {
			this[key] = user[key]
		}

		// to fill for development mode
		/* if (process.env.NODE_ENV === 'development') {

			this.stats = { 
				orders: {
					count: 146,
					categories: {
						
						Vegetarian: 149,
						" Vegetarian ": 3,
						
						" Pesce ": 2,
						Pesce: 59,
						Carne: 7,
						Secco: 31,
						pesce: 2,
						vegetarian: 9,
						Secondo: 2,
						Fresco: 79
					},
					meals: 732
				}
			}

			this.stats.orders.categories['Carne bianca'] = 47
			this.stats.orders.categories['Carne rossa'] = 66
		} */

		var categoriesMerged = {
			vegetarian: {
				searchWord: 'vegetariano',
				src: 0
			},
			vegan: {
				searchWord: 'vegano',
				src: 0
			},
			white_meat: {
				searchWord: ['carne bianca','salumi','pollo / tacchino'],
				src: 0
			},
			red_meat: {
				searchWord: ['carne rossa', 'bovino', 'ovino', 'maiale'],
				src: 0
			},
			fish: {
				searchWord: 'pesce',
				src: 0
			}
		}

		if (typeof this.stats.orders.categories === 'object') {
			var object = this.stats.orders.categories

			Object.keys(object).map((key) => {
				var value = object[key]

				Object.keys(categoriesMerged).map((newCategory) => {
					var categoryValue = categoriesMerged[newCategory]

					if (categoryValue.searchWord.indexOf(key.toLowerCase()) > -1) {
						categoriesMerged[newCategory].src += value
					}
				})
			})
		}

		this.stats.orders.categoriesMerged = categoriesMerged
	}

	isNew () {
		var self = this

		if (self.user) self = self.user

		return !self.subscription || self.subscription.status === 'pending'
	}

	isSubscribed () {
		return this.subscription && (this.subscription.status === 'started' || this.subscription.status === 'suspended')
	}

	hasProcessedOrder () {
		return this.subscription && this.subscription.orders_processed > 0
	}
}
